import React from 'react';
import { useState } from 'react';
import './totop.scss';

export function ToTop() {
  const [showScroll, setShowScroll] = useState(false)
  const checkScrollTop = () => {
    if (!showScroll && window.scrollY > 400){
      setShowScroll(true)
    } else if (showScroll && window.scrollY <= 400){
      setShowScroll(false)
    }
  };

  const scrollTop = () => {
    document.querySelectorAll('.nav-link').forEach(e => e.classList.remove('active'));
    window.scrollTo({top: 0, behavior: 'smooth'});
  };

  window.addEventListener('scroll', checkScrollTop);

  return (
    <div 
      className='totop'
      onClick={scrollTop} 
      style={{height: 40, display: showScroll ? 'flex' : 'none'}}
    ></div>
  );
}
